import React from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Figure,
  Form,
  Row,
} from "react-bootstrap";
import { photos } from "../components/shared/constraints";

const Photos = () => {
  return (
    <div className="inner-wrapper pb-0">
     <Container>
     <div className="p-md-3 p-1">
        <div class="common-heading text-start mb-3">
          {/* <h4 className="mb-3 fw-bold fs-5">Member Manager</h4> */}
        </div>

        <section className="sponser-sec pt-0 our-team-member pb-0 ">
          <div class="common-heading text-center mb-md-5 mb-3">
            <h2>
              Our All <span className="text-orange">Photos</span>{" "}
            </h2>
          </div>

          <Row className="achiever-box gx-2">
            {photos.map((sponsor, index) => (
              <Col lg={3} md={4} xs={6} className="mb-3 box-member" key={index}>
                <Card className="sponser-cards gallery-box position-relative">
                  <Figure>
                    <Card.Img variant="top" src={sponsor.image} alt="Profile" />
                  </Figure>
                </Card>
              </Col>
            ))}
          </Row>
        </section>
      </div>
     </Container>
    </div>
  );
};

export default Photos;

// No of Members,no of volumnteers,no of Active user
